import React from "react";
import ReactTooltip from "react-tooltip";

import StartCallIcon from "../../../../components/uiElements/icons/profileIcons/StartCallIcon";

class Controls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "control-button",
    };
  }

  render() {
    return (
      <div className="d-inline">
        <button
          data-tip
          data-for={this.props.control}
          onClick={this.props.onChange}
          id={this.state.id}
          style={{
            borderRadius: "50%",
            width: 50,
            height: 50,
            background:
              !this.props.isChecked &&
              (this.props.control === "callEnd"
                ? "red"
                : "var(--primary-color)"),
            outline: "none",
            boxShadow: "none",
          }}
          className="mx-3 btn"
        >
          {this.props.isSignalReceived && (
            <div
              style={{
                width: 10,
                height: 10,
                backgroundColor: "red",
                borderRadius: "50%",
                position: "absolute",
                marginLeft: 28,
                marginTop: -9,
              }}
            />
          )}
          <StartCallIcon
            className="mx-auto"
            type={this.props.control}
            active={this.props.isChecked}
          />
        </button>
        {this.props.label && (
          <ReactTooltip
            id={this.props.control}
            place="bottom"
            type="dark"
            effect="solid"
            textColor="white"
          >
            {this.props.label}
          </ReactTooltip>
        )}
      </div>
    );
  }
}
export default Controls;
